import {
	ChangeDetectionStrategy,
	Component,
	inject,
	OnInit,
	signal,
} from '@angular/core';
import { AnalysisApiService } from '@marmon/frontend/analysis';
import { DialogBase, DialogOptions } from '@marmon/frontend/common';
import { LoggerService } from '@marmon/frontend/logging';
import { AlgoliaAnalysis, Analysis } from '@marmon/shared/types/analysis';
import { TuiLoader } from '@taiga-ui/core';
import { ShareAlgoliaUsersListComponent } from '../../components';

@Component({
	selector: 'mar-share-analysis-dialog',
	imports: [ShareAlgoliaUsersListComponent, TuiLoader],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: 'share-analysis-dialog.component.html',
})
export class ShareAnalysisDialogComponent
	extends DialogBase<AlgoliaAnalysis, { analysis: AlgoliaAnalysis }>
	implements OnInit
{
	static override DialogOptions = {
		size: 'm',
		header: 'analyses.dialog.share-analysis.header',
	} as DialogOptions;

	private readonly logger = inject(LoggerService);
	readonly analysisApiService = inject(AnalysisApiService);
	readonly analysis = signal<Analysis | null>(null);

	ngOnInit() {
		this.fetchAnalysis();
	}

	readonly fetchAnalysis = () =>
		this.analysisApiService
			.findById(this.context.data.analysis.objectID)
			.then((analysis) => this.analysis.set(analysis))
			.catch((error) => {
				this.logger.captureException(error, {
					source: 'ShareAnalysisDialog.fetchAnalysis',
				});
				this.onDismiss();
			});
}
